import React from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { NavLink } from 'react-router-dom'

const DiamondEducation = () => {
    return (
        <>
            <div className='dfld_diamond_Education_Section'>
                <Container className='dfl_custome_container_staticpage'>
                    <Row className='w-100 m-auto'>
                        <Col sm={12} md={6} lg={6} className="pd-less">
                            <div className="d-secv1">
                                <h2 className="both-box-hd text-uppercase"> Certified <span className="conf-spn">DIAMONDS </span> </h2>
                                <p className="both-pr"> Every loose diamond on Cultured Brilliance is conflict-free and certified by one of the top 3 grading laboratories: IGI, GIA and GCAL. The diamond certificates are displayed along with the loose diamond on our site. </p>
                                <NavLink to="/diamonds"> Shop Now</NavLink>
                            </div>
                        </Col>
                        <Col sm={12} md={6} lg={6} className="pd-less">
                            <div className="d-secv2">
                                <h2 className="both-box-hd text-uppercase">  <span className="conf-spn">Diamond</span> Education </h2>
                                <p className="both-pr"> Each diamond is individually selected and graded against its color, clarity, cut and carat weight, but the Cultured Brilliance process goes beyond standard diamond grading. Confidently make the right choice by learning how to select your perfect diamond.</p>
                                <NavLink to="/education/loosediamonds">Learn More</NavLink>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}

export default DiamondEducation